
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexuAk_LV0Z2vXuoUwjaRkhmsoewsJAmjWgvKU3pHQuxToMeta } from "/usr/src/app/src/pages/shop/checkout/order/[id]/index.vue?macro=true";
import { default as _91_46_46_46id_93NyfyTNtzZNVXov0CMdMEmjdHimtulRSJlJg7UObSIrIMeta } from "/usr/src/app/src/pages/shop/account/orders/[...id].vue?macro=true";
import { default as addressesnM6POuaA0VIP3WrmblfXCPnLKqTN2bRGFNaW5JpiffcMeta } from "/usr/src/app/src/pages/shop/account/addresses.vue?macro=true";
import { default as index63NT8U0qypjm8fQ_lUIsablB_bxZAy6tyWFvsUi0z_IMeta } from "/usr/src/app/src/pages/shop/account/orders/index.vue?macro=true";
import { default as paymentmEoWzVDzLXoiSchVAMGaVF2ObKN5vN8DUprx_y7_9S4Meta } from "/usr/src/app/src/pages/shop/account/payment.vue?macro=true";
import { default as profile5e3p3MrvXGeZ_BshUskUMBExy3jLYQwUTOrVsWox1xMMeta } from "/usr/src/app/src/pages/shop/account/profile.vue?macro=true";
import { default as indexdqOezqvq9TDDVMksnq_R6sR7_AhCFsNb1AcP6Q6e2LsMeta } from "/usr/src/app/src/pages/shop/account/index.vue?macro=true";
import { default as indexKfdfQF9VQzp36fTImeWBkz6hbCaiVzsnGNKhTOnU3f8Meta } from "/usr/src/app/src/pages/shop/checkout/index.vue?macro=true";
export default [
  {
    name: "shop-checkout-order-id___de",
    path: "/shop/checkout/order/:id()",
    meta: indexuAk_LV0Z2vXuoUwjaRkhmsoewsJAmjWgvKU3pHQuxToMeta || {},
    component: () => import("/usr/src/app/src/pages/shop/checkout/order/[id]/index.vue")
  },
  {
    name: "shop-checkout-order-id___en",
    path: "/en/shop/checkout/order/:id()",
    meta: indexuAk_LV0Z2vXuoUwjaRkhmsoewsJAmjWgvKU3pHQuxToMeta || {},
    component: () => import("/usr/src/app/src/pages/shop/checkout/order/[id]/index.vue")
  },
  {
    name: "shop-checkout-order-id___fr",
    path: "/fr/shop/checkout/order/:id()",
    meta: indexuAk_LV0Z2vXuoUwjaRkhmsoewsJAmjWgvKU3pHQuxToMeta || {},
    component: () => import("/usr/src/app/src/pages/shop/checkout/order/[id]/index.vue")
  },
  {
    name: "shop-checkout-order-id___it",
    path: "/it/shop/checkout/order/:id()",
    meta: indexuAk_LV0Z2vXuoUwjaRkhmsoewsJAmjWgvKU3pHQuxToMeta || {},
    component: () => import("/usr/src/app/src/pages/shop/checkout/order/[id]/index.vue")
  },
  {
    name: "shop-account-orders-id___de",
    path: "/shop/account/orders/:id(.*)*",
    meta: _91_46_46_46id_93NyfyTNtzZNVXov0CMdMEmjdHimtulRSJlJg7UObSIrIMeta || {},
    component: () => import("/usr/src/app/src/pages/shop/account/orders/[...id].vue")
  },
  {
    name: "shop-account-orders-id___en",
    path: "/en/shop/account/orders/:id(.*)*",
    meta: _91_46_46_46id_93NyfyTNtzZNVXov0CMdMEmjdHimtulRSJlJg7UObSIrIMeta || {},
    component: () => import("/usr/src/app/src/pages/shop/account/orders/[...id].vue")
  },
  {
    name: "shop-account-orders-id___fr",
    path: "/fr/shop/account/orders/:id(.*)*",
    meta: _91_46_46_46id_93NyfyTNtzZNVXov0CMdMEmjdHimtulRSJlJg7UObSIrIMeta || {},
    component: () => import("/usr/src/app/src/pages/shop/account/orders/[...id].vue")
  },
  {
    name: "shop-account-orders-id___it",
    path: "/it/shop/account/orders/:id(.*)*",
    meta: _91_46_46_46id_93NyfyTNtzZNVXov0CMdMEmjdHimtulRSJlJg7UObSIrIMeta || {},
    component: () => import("/usr/src/app/src/pages/shop/account/orders/[...id].vue")
  },
  {
    name: "account-recover-password___de",
    path: "/account/recover/password",
    component: () => import("/usr/src/app/src/pages/account/recover/password.vue")
  },
  {
    name: "account-recover-password___en",
    path: "/en/account/recover/password",
    component: () => import("/usr/src/app/src/pages/account/recover/password.vue")
  },
  {
    name: "account-recover-password___fr",
    path: "/fr/account/recover/password",
    component: () => import("/usr/src/app/src/pages/account/recover/password.vue")
  },
  {
    name: "account-recover-password___it",
    path: "/it/account/recover/password",
    component: () => import("/usr/src/app/src/pages/account/recover/password.vue")
  },
  {
    name: "shop-account-addresses___de",
    path: "/shop/account/addresses",
    meta: addressesnM6POuaA0VIP3WrmblfXCPnLKqTN2bRGFNaW5JpiffcMeta || {},
    component: () => import("/usr/src/app/src/pages/shop/account/addresses.vue")
  },
  {
    name: "shop-account-addresses___en",
    path: "/en/shop/account/addresses",
    meta: addressesnM6POuaA0VIP3WrmblfXCPnLKqTN2bRGFNaW5JpiffcMeta || {},
    component: () => import("/usr/src/app/src/pages/shop/account/addresses.vue")
  },
  {
    name: "shop-account-addresses___fr",
    path: "/fr/shop/account/addresses",
    meta: addressesnM6POuaA0VIP3WrmblfXCPnLKqTN2bRGFNaW5JpiffcMeta || {},
    component: () => import("/usr/src/app/src/pages/shop/account/addresses.vue")
  },
  {
    name: "shop-account-addresses___it",
    path: "/it/shop/account/addresses",
    meta: addressesnM6POuaA0VIP3WrmblfXCPnLKqTN2bRGFNaW5JpiffcMeta || {},
    component: () => import("/usr/src/app/src/pages/shop/account/addresses.vue")
  },
  {
    name: "shop-account-orders___de",
    path: "/shop/account/orders",
    meta: index63NT8U0qypjm8fQ_lUIsablB_bxZAy6tyWFvsUi0z_IMeta || {},
    component: () => import("/usr/src/app/src/pages/shop/account/orders/index.vue")
  },
  {
    name: "shop-account-orders___en",
    path: "/en/shop/account/orders",
    meta: index63NT8U0qypjm8fQ_lUIsablB_bxZAy6tyWFvsUi0z_IMeta || {},
    component: () => import("/usr/src/app/src/pages/shop/account/orders/index.vue")
  },
  {
    name: "shop-account-orders___fr",
    path: "/fr/shop/account/orders",
    meta: index63NT8U0qypjm8fQ_lUIsablB_bxZAy6tyWFvsUi0z_IMeta || {},
    component: () => import("/usr/src/app/src/pages/shop/account/orders/index.vue")
  },
  {
    name: "shop-account-orders___it",
    path: "/it/shop/account/orders",
    meta: index63NT8U0qypjm8fQ_lUIsablB_bxZAy6tyWFvsUi0z_IMeta || {},
    component: () => import("/usr/src/app/src/pages/shop/account/orders/index.vue")
  },
  {
    name: "shop-account-payment___de",
    path: "/shop/account/payment",
    meta: paymentmEoWzVDzLXoiSchVAMGaVF2ObKN5vN8DUprx_y7_9S4Meta || {},
    component: () => import("/usr/src/app/src/pages/shop/account/payment.vue")
  },
  {
    name: "shop-account-payment___en",
    path: "/en/shop/account/payment",
    meta: paymentmEoWzVDzLXoiSchVAMGaVF2ObKN5vN8DUprx_y7_9S4Meta || {},
    component: () => import("/usr/src/app/src/pages/shop/account/payment.vue")
  },
  {
    name: "shop-account-payment___fr",
    path: "/fr/shop/account/payment",
    meta: paymentmEoWzVDzLXoiSchVAMGaVF2ObKN5vN8DUprx_y7_9S4Meta || {},
    component: () => import("/usr/src/app/src/pages/shop/account/payment.vue")
  },
  {
    name: "shop-account-payment___it",
    path: "/it/shop/account/payment",
    meta: paymentmEoWzVDzLXoiSchVAMGaVF2ObKN5vN8DUprx_y7_9S4Meta || {},
    component: () => import("/usr/src/app/src/pages/shop/account/payment.vue")
  },
  {
    name: "shop-account-profile___de",
    path: "/shop/account/profile",
    meta: profile5e3p3MrvXGeZ_BshUskUMBExy3jLYQwUTOrVsWox1xMMeta || {},
    component: () => import("/usr/src/app/src/pages/shop/account/profile.vue")
  },
  {
    name: "shop-account-profile___en",
    path: "/en/shop/account/profile",
    meta: profile5e3p3MrvXGeZ_BshUskUMBExy3jLYQwUTOrVsWox1xMMeta || {},
    component: () => import("/usr/src/app/src/pages/shop/account/profile.vue")
  },
  {
    name: "shop-account-profile___fr",
    path: "/fr/shop/account/profile",
    meta: profile5e3p3MrvXGeZ_BshUskUMBExy3jLYQwUTOrVsWox1xMMeta || {},
    component: () => import("/usr/src/app/src/pages/shop/account/profile.vue")
  },
  {
    name: "shop-account-profile___it",
    path: "/it/shop/account/profile",
    meta: profile5e3p3MrvXGeZ_BshUskUMBExy3jLYQwUTOrVsWox1xMMeta || {},
    component: () => import("/usr/src/app/src/pages/shop/account/profile.vue")
  },
  {
    name: "shop-account-recovery___de",
    path: "/shop/account/recovery",
    component: () => import("/usr/src/app/src/pages/shop/account/recovery.vue")
  },
  {
    name: "shop-account-recovery___en",
    path: "/en/shop/account/recovery",
    component: () => import("/usr/src/app/src/pages/shop/account/recovery.vue")
  },
  {
    name: "shop-account-recovery___fr",
    path: "/fr/shop/account/recovery",
    component: () => import("/usr/src/app/src/pages/shop/account/recovery.vue")
  },
  {
    name: "shop-account-recovery___it",
    path: "/it/shop/account/recovery",
    component: () => import("/usr/src/app/src/pages/shop/account/recovery.vue")
  },
  {
    name: "registration-conference-id___de",
    path: "/registration/conference/:id()",
    component: () => import("/usr/src/app/src/pages/registration/conference/[id].vue")
  },
  {
    name: "registration-conference-id___en",
    path: "/en/registration/conference/:id()",
    component: () => import("/usr/src/app/src/pages/registration/conference/[id].vue")
  },
  {
    name: "registration-conference-id___fr",
    path: "/fr/registration/conference/:id()",
    component: () => import("/usr/src/app/src/pages/registration/conference/[id].vue")
  },
  {
    name: "registration-conference-id___it",
    path: "/it/registration/conference/:id()",
    component: () => import("/usr/src/app/src/pages/registration/conference/[id].vue")
  },
  {
    name: "registration-module-id___de",
    path: "/registration/module/:id()",
    component: () => import("/usr/src/app/src/pages/registration/module/[id].vue")
  },
  {
    name: "registration-module-id___en",
    path: "/en/registration/module/:id()",
    component: () => import("/usr/src/app/src/pages/registration/module/[id].vue")
  },
  {
    name: "registration-module-id___fr",
    path: "/fr/registration/module/:id()",
    component: () => import("/usr/src/app/src/pages/registration/module/[id].vue")
  },
  {
    name: "registration-module-id___it",
    path: "/it/registration/module/:id()",
    component: () => import("/usr/src/app/src/pages/registration/module/[id].vue")
  },
  {
    name: "registration-seminar-all___de",
    path: "/registration/seminar/:all(.*)*",
    component: () => import("/usr/src/app/src/pages/registration/seminar/[...all].vue")
  },
  {
    name: "registration-seminar-all___en",
    path: "/en/registration/seminar/:all(.*)*",
    component: () => import("/usr/src/app/src/pages/registration/seminar/[...all].vue")
  },
  {
    name: "registration-seminar-all___fr",
    path: "/fr/registration/seminar/:all(.*)*",
    component: () => import("/usr/src/app/src/pages/registration/seminar/[...all].vue")
  },
  {
    name: "registration-seminar-all___it",
    path: "/it/registration/seminar/:all(.*)*",
    component: () => import("/usr/src/app/src/pages/registration/seminar/[...all].vue")
  },
  {
    name: "shop-account___de",
    path: "/shop/account",
    meta: indexdqOezqvq9TDDVMksnq_R6sR7_AhCFsNb1AcP6Q6e2LsMeta || {},
    component: () => import("/usr/src/app/src/pages/shop/account/index.vue")
  },
  {
    name: "shop-account___en",
    path: "/en/shop/account",
    meta: indexdqOezqvq9TDDVMksnq_R6sR7_AhCFsNb1AcP6Q6e2LsMeta || {},
    component: () => import("/usr/src/app/src/pages/shop/account/index.vue")
  },
  {
    name: "shop-account___fr",
    path: "/fr/shop/account",
    meta: indexdqOezqvq9TDDVMksnq_R6sR7_AhCFsNb1AcP6Q6e2LsMeta || {},
    component: () => import("/usr/src/app/src/pages/shop/account/index.vue")
  },
  {
    name: "shop-account___it",
    path: "/it/shop/account",
    meta: indexdqOezqvq9TDDVMksnq_R6sR7_AhCFsNb1AcP6Q6e2LsMeta || {},
    component: () => import("/usr/src/app/src/pages/shop/account/index.vue")
  },
  {
    name: "shop-cart___de",
    path: "/shop/cart",
    component: () => import("/usr/src/app/src/pages/shop/cart.vue")
  },
  {
    name: "shop-cart___en",
    path: "/en/shop/cart",
    component: () => import("/usr/src/app/src/pages/shop/cart.vue")
  },
  {
    name: "shop-cart___fr",
    path: "/fr/shop/cart",
    component: () => import("/usr/src/app/src/pages/shop/cart.vue")
  },
  {
    name: "shop-cart___it",
    path: "/it/shop/cart",
    component: () => import("/usr/src/app/src/pages/shop/cart.vue")
  },
  {
    name: "shop-checkout___de",
    path: "/shop/checkout",
    meta: indexKfdfQF9VQzp36fTImeWBkz6hbCaiVzsnGNKhTOnU3f8Meta || {},
    component: () => import("/usr/src/app/src/pages/shop/checkout/index.vue")
  },
  {
    name: "shop-checkout___en",
    path: "/en/shop/checkout",
    meta: indexKfdfQF9VQzp36fTImeWBkz6hbCaiVzsnGNKhTOnU3f8Meta || {},
    component: () => import("/usr/src/app/src/pages/shop/checkout/index.vue")
  },
  {
    name: "shop-checkout___fr",
    path: "/fr/shop/checkout",
    meta: indexKfdfQF9VQzp36fTImeWBkz6hbCaiVzsnGNKhTOnU3f8Meta || {},
    component: () => import("/usr/src/app/src/pages/shop/checkout/index.vue")
  },
  {
    name: "shop-checkout___it",
    path: "/it/shop/checkout",
    meta: indexKfdfQF9VQzp36fTImeWBkz6hbCaiVzsnGNKhTOnU3f8Meta || {},
    component: () => import("/usr/src/app/src/pages/shop/checkout/index.vue")
  },
  {
    name: "shop-login___de",
    path: "/shop/login",
    component: () => import("/usr/src/app/src/pages/shop/login.vue")
  },
  {
    name: "shop-login___en",
    path: "/en/shop/login",
    component: () => import("/usr/src/app/src/pages/shop/login.vue")
  },
  {
    name: "shop-login___fr",
    path: "/fr/shop/login",
    component: () => import("/usr/src/app/src/pages/shop/login.vue")
  },
  {
    name: "shop-login___it",
    path: "/it/shop/login",
    component: () => import("/usr/src/app/src/pages/shop/login.vue")
  },
  {
    name: "shop-register___de",
    path: "/shop/register",
    component: () => import("/usr/src/app/src/pages/shop/register.vue")
  },
  {
    name: "shop-register___en",
    path: "/en/shop/register",
    component: () => import("/usr/src/app/src/pages/shop/register.vue")
  },
  {
    name: "shop-register___fr",
    path: "/fr/shop/register",
    component: () => import("/usr/src/app/src/pages/shop/register.vue")
  },
  {
    name: "shop-register___it",
    path: "/it/shop/register",
    component: () => import("/usr/src/app/src/pages/shop/register.vue")
  },
  {
    name: "shop-search___de",
    path: "/shop/search",
    component: () => import("/usr/src/app/src/pages/shop/search.vue")
  },
  {
    name: "shop-search___en",
    path: "/en/shop/search",
    component: () => import("/usr/src/app/src/pages/shop/search.vue")
  },
  {
    name: "shop-search___fr",
    path: "/fr/shop/search",
    component: () => import("/usr/src/app/src/pages/shop/search.vue")
  },
  {
    name: "shop-search___it",
    path: "/it/shop/search",
    component: () => import("/usr/src/app/src/pages/shop/search.vue")
  },
  {
    name: "weiterbildung-suche___de",
    path: "/weiterbildung/suche",
    component: () => import("/usr/src/app/src/pages/weiterbildung/suche.vue")
  },
  {
    name: "weiterbildung-suche___en",
    path: "/en/weiterbildung/suche",
    component: () => import("/usr/src/app/src/pages/weiterbildung/suche.vue")
  },
  {
    name: "weiterbildung-suche___fr",
    path: "/fr/weiterbildung/suche",
    component: () => import("/usr/src/app/src/pages/weiterbildung/suche.vue")
  },
  {
    name: "weiterbildung-suche___it",
    path: "/it/weiterbildung/suche",
    component: () => import("/usr/src/app/src/pages/weiterbildung/suche.vue")
  },
  {
    name: "preview-id___de",
    path: "/preview/:id(.*)*",
    component: () => import("/usr/src/app/src/pages/preview/[...id].vue")
  },
  {
    name: "preview-id___en",
    path: "/en/preview/:id(.*)*",
    component: () => import("/usr/src/app/src/pages/preview/[...id].vue")
  },
  {
    name: "preview-id___fr",
    path: "/fr/preview/:id(.*)*",
    component: () => import("/usr/src/app/src/pages/preview/[...id].vue")
  },
  {
    name: "preview-id___it",
    path: "/it/preview/:id(.*)*",
    component: () => import("/usr/src/app/src/pages/preview/[...id].vue")
  },
  {
    name: "shop-slug___de",
    path: "/shop/:slug(.*)*",
    component: () => import("/usr/src/app/src/pages/shop/[...slug].vue")
  },
  {
    name: "shop-slug___en",
    path: "/en/shop/:slug(.*)*",
    component: () => import("/usr/src/app/src/pages/shop/[...slug].vue")
  },
  {
    name: "shop-slug___fr",
    path: "/fr/shop/:slug(.*)*",
    component: () => import("/usr/src/app/src/pages/shop/[...slug].vue")
  },
  {
    name: "shop-slug___it",
    path: "/it/shop/:slug(.*)*",
    component: () => import("/usr/src/app/src/pages/shop/[...slug].vue")
  },
  {
    name: "healthcheck___de",
    path: "/healthcheck",
    component: () => import("/usr/src/app/src/pages/healthcheck.vue")
  },
  {
    name: "healthcheck___en",
    path: "/en/healthcheck",
    component: () => import("/usr/src/app/src/pages/healthcheck.vue")
  },
  {
    name: "healthcheck___fr",
    path: "/fr/healthcheck",
    component: () => import("/usr/src/app/src/pages/healthcheck.vue")
  },
  {
    name: "healthcheck___it",
    path: "/it/healthcheck",
    component: () => import("/usr/src/app/src/pages/healthcheck.vue")
  },
  {
    name: "search___de",
    path: "/search",
    component: () => import("/usr/src/app/src/pages/search.vue")
  },
  {
    name: "search___en",
    path: "/en/search",
    component: () => import("/usr/src/app/src/pages/search.vue")
  },
  {
    name: "search___fr",
    path: "/fr/search",
    component: () => import("/usr/src/app/src/pages/search.vue")
  },
  {
    name: "search___it",
    path: "/it/search",
    component: () => import("/usr/src/app/src/pages/search.vue")
  },
  {
    name: "shop___de",
    path: "/shop",
    meta: {"middleware":"get-layout"},
    component: () => import("/usr/src/app/src/pages/shop/index.vue")
  },
  {
    name: "shop___en",
    path: "/en/shop",
    meta: {"middleware":"get-layout"},
    component: () => import("/usr/src/app/src/pages/shop/index.vue")
  },
  {
    name: "shop___fr",
    path: "/fr/shop",
    meta: {"middleware":"get-layout"},
    component: () => import("/usr/src/app/src/pages/shop/index.vue")
  },
  {
    name: "shop___it",
    path: "/it/shop",
    meta: {"middleware":"get-layout"},
    component: () => import("/usr/src/app/src/pages/shop/index.vue")
  },
  {
    name: "all___de",
    path: "/:all(.*)*",
    meta: {"middleware":"get-layout"},
    component: () => import("/usr/src/app/src/pages/[...all].vue")
  },
  {
    name: "all___en",
    path: "/en/:all(.*)*",
    meta: {"middleware":"get-layout"},
    component: () => import("/usr/src/app/src/pages/[...all].vue")
  },
  {
    name: "all___fr",
    path: "/fr/:all(.*)*",
    meta: {"middleware":"get-layout"},
    component: () => import("/usr/src/app/src/pages/[...all].vue")
  },
  {
    name: "all___it",
    path: "/it/:all(.*)*",
    meta: {"middleware":"get-layout"},
    component: () => import("/usr/src/app/src/pages/[...all].vue")
  }
]